import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Image, Stack, Text } from '@mantine/core';
import classes from './Divider.module.css';
import { KycCharacter } from './KycCharacter';
export const KycCongratsMobile: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack hiddenFrom="sm" mb={40}>
      <Image src="/assets/kyc/celebration.svg" w={80} h={80} mx="auto" />
      <Box>
        <Text fz={28} c="var(--text-prime)" className={gunterzBold.className} ta="center">
          {i18n._('Congrats,')}
        </Text>
        <Text fz={28} c="var(--text-white)" className={gunterzBold.className} ta="center" style={{
        textWrap: 'nowrap'
      }}>
          {i18n._(' Armor Unlocked!')}
        </Text>
      </Box>

      <Divider my={14} classNames={classes} />

      <Text fz={20} c="var(--text-dark)" className={gunterzBold.className} ta="center">
        {i18n._('You’ve unlocked THE ')}
        <Text span inherit c="var(--text-pink)">
          {i18n._('GALAXY SILVER ')}
        </Text>
        {i18n._('ARMOR')}
      </Text>

      <Divider my={14} classNames={classes} />

      <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} ta="center">
        {i18n._('Your dedication has paid off, and now your PrimeOrb is equipped with the ultimate protection.')}
      </Text>

      <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} ta="center">
        {i18n._('Feast your eyes on your new armor—only the best for a true PrimeRoller like you!')}
      </Text>

      <KycCharacter />
    </Stack>;
};